const autoRefresh = function() {
    window.location = window.location.href;
};

export default autoRefresh;